import { useStorage } from '@vueuse/core'

const {
  isWidget,
  widgetSettingsOptionsType,
  widgetSettingsOptionsSpecificPages,
  widgetSettingsOptionsView,
} = useWidgetSettings()

const viewOptions = {
  'schedule.month': 'month',
  'schedule.week': 'week',
  'schedule.day': 'day',
  'month': 'month',
  'week': 'week',
  'day': 'day',
}

function getDefaultView() {
  if (!isWidget)
    return 'month'

  if (widgetSettingsOptionsView && viewOptions[widgetSettingsOptionsView])
    return viewOptions[widgetSettingsOptionsView]
  if (widgetSettingsOptionsType === 'specific_pages' && widgetSettingsOptionsSpecificPages)
    return widgetSettingsOptionsSpecificPages?.find(page => viewOptions[page])
  return 'month'
}

const view = useStorage('calendar-view', getDefaultView())

export function useCalendarViewState() {
  return view
}
